import RichText from "@/components/RichText";

const DEFAULTS = {
  eyebrow: "",
  heading: "Avant / Après",
  subheading: "",
  before_image: "",
  after_image: "",
  before_label: "Avant",
  after_label: "Après",
  variant: "light",
  anchor_id: "",
};

function Panel({ url, label, dark }) {
  return (
    <figure className="relative overflow-hidden rounded-2xl bg-sand">
      <div className="aspect-[4/3] w-full">
        {url ? (
          <img src={url} alt={label} className="h-full w-full object-cover" loading="lazy" />
        ) : (
          <div className="h-full w-full flex items-center justify-center text-ash text-[13px]">Image</div>
        )}
      </div>
      {label && (
        <figcaption className="absolute top-3 left-3 rounded-full bg-black/70 px-3 py-1 text-[12px] font-semibold uppercase tracking-wide text-white">
          {label}
        </figcaption>
      )}
    </figure>
  );
}

export default function BeforeAfterSection({ props = {} }) {
  const t = { ...DEFAULTS, ...props };
  const dark = t.variant === "dark";
  if (!t.heading && !t.before_image && !t.after_image) return null;

  return (
    <section
      id={t.anchor_id || undefined}
      data-testid="before-after-section"
      className={`scroll-mt-28 ${dark ? "bg-ink" : ""}`}
    >
      <div className="max-w-[1080px] mx-auto px-6 md:px-10 py-20 md:py-28 scroll-mt-28">
        {(t.eyebrow || t.heading || t.subheading) && (
          <div className="text-center max-w-2xl mx-auto mb-12">
            {t.eyebrow && (
              <RichText
                as="span"
                className={`inline-flex items-center gap-1.5 rounded-full border px-3.5 py-1.5 text-[12px] font-semibold tracking-wide uppercase mb-4 ${
                  dark ? "border-white/15 bg-white/5 text-gold" : "border-stone bg-sand text-gold"
                }`}
                html={t.eyebrow}
              />
            )}
            {t.heading && (
              <RichText
                as="h2"
                className={`font-display font-semibold text-[30px] md:text-[34px] leading-tight tracking-[-0.02em] ${dark ? "text-white" : "text-ink"}`}
                html={t.heading}
              />
            )}
            {t.subheading && (
              <RichText as="p" preserveParagraphs className={`text-[16px] mt-4 ${dark ? "text-white/60" : "text-graphite"}`} html={t.subheading} />
            )}
          </div>
        )}

        <div className="grid sm:grid-cols-2 gap-4 md:gap-6 items-start">
          <Panel url={(t.before_image || "").trim()} label={t.before_label} dark={dark} />
          <Panel url={(t.after_image || "").trim()} label={t.after_label} dark={dark} />
        </div>
      </div>
    </section>
  );
}
